import { render, staticRenderFns } from "./ServicesPaymentReceipt.vue?vue&type=template&id=d1f33008&scoped=true&"
import script from "./ServicesPaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./ServicesPaymentReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f33008",
  null
  
)

export default component.exports